import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress, Grid } from '@material-ui/core';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { ITEMS_PER_PAGE_20 } from '@moderepo/mode-app-components';
import { useRitzTranslation } from '../../utils/customHooks';
import { RCRobotsListingContainer, RobotsTableHiddenFields } from './RCRobotsListingContainer';



/**
 * Define the list of fields we want to hide in the RobotsTable. This will depends on if there is an robot selected. If there is a robot
 * selected and are showing robot details on the Right side, we can hide some of the unnecessary columns.
 * This will create 2 set of RobotTableHiddenFields. The first set will show more column which should be used when there is no robot selected.
 * The second set has more columns hidden which is to be used when a robot is selected
 */
const robotsTableDisplayHiddenFields: RobotsTableHiddenFields = {
    overrideRobotDefinition: true,
    updatedAt              : true,
    availability           : true,
    createdAt              : true,
};



/**
 * This page Display ALL a Robots for a Project
 */
export const RCRobotsPage = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);
    const userId = params.userId ? Number(params.userId) : undefined;
    const homeId = params.homeId ? Number(params.homeId) : undefined;
    const deviceId = params.deviceId ? Number(params.deviceId) : undefined;

    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);
    const { trans } = useRitzTranslation(project);

    // For ProjectRobots page, we will not filter anything and will show ALL robots
    const [robotsTableDisplayFilters] = useState<{
        readonly homeId?: number;
        readonly deviceId?: number;
    }>({ });


    return (
        <div className="page-main-content">
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.project_robots')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.project_robots')}
                    </div>
                </div>
            </div>

            {project && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <RCRobotsListingContainer
                            projectId={projectId}
                            userId={userId}
                            homeId={homeId}
                            deviceId={deviceId}
                            gatewayDependentRobotsOnly={false}
                            canCreateRobots={Boolean(homeId)}
                            itemsPerPage={ITEMS_PER_PAGE_20}
                            hiddenFields={robotsTableDisplayHiddenFields}
                            filters={robotsTableDisplayFilters}
                        />
                    </Grid>
                </Grid>
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
